import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import store from "./redux/store";

import "react-tooltip/dist/react-tooltip.css";
import "animate.css";
// import store from "./redux/store"
// import App from './oldCode/App';

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ThemeProvider from "./context/theme";

ReactDOM.render(
  // <SocketProvider url={""} >
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
  // </SocketProvider>,

  document.getElementById("root")
);
